import { cn, Flex } from '@bridebook/aura';
import { FloatingEditButton } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/floating-edit-button';

type Props = {
  className?: string;
};

export const EmptyPhotoPlaceholder = ({ className }: Props) => (
  <Flex className={cn('bg-space-10 relative h-full w-full items-center justify-center', className)}>
    <FloatingEditButton detailsSectionId="photos" />
  </Flex>
);
